"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/HTFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_104)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_104`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V12.0702H-6V0Z",
					fill: "#A2001D"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 12.0702H30V24.1404H-6V12.0702Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M20.7649 17.6491L12.9965 16.6807L5.22107 17.6491V5.99298H20.7649V17.6491Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.9965 16.6807C15.1436 16.6807 16.8842 14.9401 16.8842 12.793C16.8842 10.6459 15.1436 8.90527 12.9965 8.90527C10.8494 8.90527 9.10876 10.6459 9.10876 12.793C9.10876 14.9401 10.8494 16.6807 12.9965 16.6807Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.9965 14.7368C14.07 14.7368 14.9403 13.8665 14.9403 12.793C14.9403 11.7194 14.07 10.8491 12.9965 10.8491C11.9229 10.8491 11.0526 11.7194 11.0526 12.793C11.0526 13.8665 11.9229 14.7368 12.9965 14.7368Z",
					fill: "#A2001D"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.0771 7.93683H15.9087L12.9964 10.8491L10.0771 7.93683Z",
					fill: "#6DA544"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.021 9.88068H13.9649V15.7052H12.021V9.88068Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M16.0983 15.1228H9.88774L5.22107 17.6491H20.7649L16.0983 15.1228Z",
					fill: "#6DA544"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_104`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as HTFlag };
